import React from 'react'
import { ColumnsType, TablePaginationConfig, TableProps } from 'antd/lib/table'

import SEOTable from 'container/SEOTools/components/SEOTable/SEOTable'
import InsightWrapper from '../InsightWrapper'

import { Impact, InsightRedirect } from '../types'

import s from './Table.module.css'

type Props<T> = {
  data?: T[]
  columns?: ColumnsType<T>
  pagination?: TablePaginationConfig | false
  showFooter?: boolean
  onHeaderRow?: TableProps<T>['onHeaderRow']
  insights?: Record<
    string,
    {
      actionable: InsightRedirect
      actionable_text: string
      display_text: string
      impact: Impact
      technical_text: string
    }
  >
}

export const Table = <T extends object>({
  data,
  columns,
  pagination = false,
  showFooter = true,
  insights,
}: Props<T>): React.ReactElement => {
  const insight = insights?.[Object.keys(insights)[0]]

  const renderInsight = () =>
    showFooter &&
    insight && (
      <InsightWrapper
        description={insight.display_text}
        cta={insight.actionable_text}
        impact={insight.impact}
        redirectUrl={insight.actionable}
      />
    )

  return (
    <div className={s.table}>
      <SEOTable<T>
        rowKey="id"
        pagination={pagination}
        columns={columns}
        dataSource={data}
        footer={renderInsight}
      />
    </div>
  )
}
